import { css } from '@emotion/react';
import { math } from 'polished';

export default ($) => {
  return css`
    .img-fluid {
      max-width: 100%;
      height: auto;
    }

    .img-thumbnail {
      padding: ${$.thumbnailPadding};
      background-color: ${$.thumbnailBg};
      border: ${$.thumbnailBorderWidth} solid ${$.thumbnailBorderColor};
      border-radius: ${$.thumbnailBorderRadius};
      box-shadow: ${$.thumbnailBoxShadow};
      max-width: 100%;
      height: auto;
    }

    .figure {
      display: inline-block;
    }

    .figure-img {
      margin-bottom: ${math(`${$.spacer} * 0.5`)};
      line-height: 1;
    }

    .figure-caption {
      font-size: ${$.figureCaptionFontSize};
      color: ${$.figureCaptionColor};
    }
  `;
}
